import React from 'react';
/** Full-color mark for light surfaces (nav bars, white top bars). */
const LOGO_ON_LIGHT = 'https://cdn.magicpatterns.com/uploads/wkQqc9S9BvV2ZaaGf2SzsH/Nav_Bar.png';
/** All-white mark on its own violet plate, for the dark footer band. */
const LOGO_ON_DARK = 'https://cdn.magicpatterns.com/uploads/fJub4AFs7TJYVZbr1gNok5/footer.png';
type LogoProps = {
  /** 'dark' for light backgrounds (header), 'light' for dark bands (footer). */
  variant?: 'dark' | 'light';
  size?: 'sm' | 'md';
  className?: string;
};
/**
 * findonlinecolleges.org brand mark. Two cuts of the same artwork: the
 * full-color version for white surfaces and the reversed white version for the
 * dark footer band.
 */
export function Logo({
  variant = 'dark',
  size = 'md',
  className = ''
}: LogoProps) {
  const isLight = variant === 'light';
  const height = size === 'sm' ? 'h-7' : 'h-9 sm:h-10';
  return <img src={isLight ? LOGO_ON_DARK : LOGO_ON_LIGHT} alt="findonlinecolleges.org" className={`${height} w-auto object-contain ${isLight ? 'rounded-md' : ''} ${className}`} data-id="element-775" data-mp="32jqn0dt6d80j" />;
}